import React from 'react';

function AssistanceText() {
  return (
    <p> Increasingly, requests for international assistance are
    articulated in States' national reports on the implementation
    of the Programme of Action on small arms light weapons and its
     International Tracing Instrument. Such requests are visually
     presented by theme, to facilitate matching of assistance needs with available resources, while ensuring the guiding principle of national ownership. In addition, information on international
     assistance in the area of reintegration and small arms control
     is fed from OECD's Creditors Reporting System (CRS). This data is customized and presented in not only donors'
     but also recipients' profiles. <i>(Information is reflected in the
     ‘international assistance section below if national reports are
     submitted online or consistent with the latest reporting template.)</i>
    </p>
  );
}

export default AssistanceText;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/AssistanceLandingText.js